/**
 * Sets the CSS custom property --accent on :root. Downstream color-mix()
 * expressions derive --accent-dark and --accent-soft from it automatically.
 */
export function setAccent(hex: string): void {
  document.documentElement.style.setProperty('--accent', hex);
}

export const ACCENT_PRESETS = ['#1f8a5b', '#2a6fdb', '#4b3fb5', '#c2703d'] as const;
export type AccentPreset = (typeof ACCENT_PRESETS)[number];
